import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-3dc",
  "use": "app-icon-3dc-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"app-icon-3dc\"><path d=\"M11 1.08a8.28 8.28 0 015 7.25 8 8 0 01-.77 3.43l-1.81-.86A5.82 5.82 0 0014 8.33a6.21 6.21 0 00-3.8-5.41l.8-1.84zM5.43 13.76c1.63.76 3.51.76 5.14 0l.85 1.8a8 8 0 01-6.85 0l.86-1.8zM2 8.33A5.92 5.92 0 002.6 11l-1.8.83a8 8 0 01-.8-3.5A8.51 8.51 0 015 1l.78 1.8A6.56 6.56 0 002 8.33zM8 4a2 2 0 110-4 2 2 0 010 4zM3 15.33a2 2 0 110-4 2 2 0 010 4zm10 0a2 2 0 110-4 2 2 0 010 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol